export const getNextClubDate = (club) => {
    const now = new Date();
    const dayMap = { 'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3, 'Thursday': 4, 'Friday': 5, 'Saturday': 6 };

    // Normalize Schedule
    let schedule = club.schedule;
    if (!schedule && club.meetingDay && club.meetingTime) {
        schedule = [{ day: club.meetingDay, time: club.meetingTime }];
    }

    if (!schedule || schedule.length === 0) return null;

    // Check next 60 days (to be safe for monthly? usually weekly)
    // We just need the *first* upcoming one.
    for (let d = 0; d < 60; d++) {
        const checkDate = new Date();
        checkDate.setDate(now.getDate() + d);
        const currentDay = checkDate.getDay();

        for (const slot of schedule) {
            const targetDay = dayMap[slot.day];
            if (targetDay === undefined) continue;

            if (currentDay === targetDay) {
                const [hours, minutes] = slot.time.split(':').map(Number);
                const instanceDate = new Date(checkDate);
                instanceDate.setHours(hours, minutes, 0, 0);

                // If today, must be in future
                if (instanceDate > now) {
                    return instanceDate;
                }
            }
        }
    }
    return null;
};
